<template>
  <div class="dashboard">
    <app-header-container>
      <div class="d-flex align-center">
        <div>{{ $t('views.Dashboard.index.home') }}</div>
<!--        <div class="icon-settings ml-1 text-color-secondary" style="transform: scale(.9) translateY(3%);"></div>-->
      </div>

      <template v-slot:controls v-if="screen.breakPoint.tabPort">
        <div class="d-flex align-center justify-end">
          <autocomplete
            not-empty
            value-field="id"
            item-text="fullName"
            v-model="currContractId"
            :items="contracts"
            :placeholder="$t('views.Orders.contractSelect.label')"
            :label="$t('views.Orders.contractSelect.label')"
            class="mr-2"
            v-if="contracts.length"
          ></autocomplete>

          <add-widget v-if="screen.breakPoint.tabPort"></add-widget>
        </div>
      </template>
    </app-header-container>

    <app-controls-container v-if="showNotification">
      <dashboard-notification type="error" class=""></dashboard-notification>
    </app-controls-container>

    <mobile-widgets v-if="!screen.breakPoint.tabPort" style="margin-bottom: 70px;"></mobile-widgets>
    <desktop-widgets v-else></desktop-widgets>
  </div>
</template>

<script>
import Autocomplete from '@/ui/controls/Autocomplete'

import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import AppControlsContainer from '@/ui/layout/AppControlsContainer'

import DashboardNotification from '@/components/DashboardNotification'

import DesktopWidgets from '@/widgets/Desktop'
import MobileWidgets from '@/widgets/Mobile'

import AddWidget from '@/widgets/AddWidget'

import screen from '@/mixins/screen'
import profile from '@/mixins/profile'
import currContractId from '@/mixins/currContractId'
import contracts from '@/mixins/contracts'

export default {
  mixins: [screen, profile, currContractId, contracts],

  components: {
    Autocomplete,

    DesktopWidgets,
    MobileWidgets,
    AppHeaderContainer,
    AppControlsContainer,

    DashboardNotification,

    AddWidget
  },

  computed: {
    showNotification () {
      const profile = this.profile
      const status = profile.status
      const isActive = profile.active && true

      return status === 'NEW' ||
        // status === 'READY' ||
        status === 'VERIFICATION' ||
        status === 'CORRECTION' ||
        status === 'OUT_PLATFORM' ||
        status === 'DEACTIVATED' ||
        this.hasNoDocuments ||
        !isActive
    }
  }
}
</script>
